import script from "./ChatMessaging.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatMessaging.vue?vue&type=script&setup=true&lang=js"

import "./ChatMessaging.vue?vue&type=style&index=0&id=14c8c2c3&lang=scss"

const __exports__ = script;

export default __exports__